import { render, staticRenderFns } from "./AddIns.vue?vue&type=template&id=b2333f50&scoped=true&"
import script from "./AddIns.vue?vue&type=script&lang=js&"
export * from "./AddIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2333f50",
  null
  
)

export default component.exports